<div class="col-8 block bg-dashboard bg-shadow p-5 border-radius-right-dashboard colorTm  sm:flex-row col-11">
  <div class="w-full p-4 text-black">
    <label class="w-full text-3xl">Cerchi il lavoro dei tuoi <label class="text-primary">sogni</label>?</label>
    <br><br>
    <label class="font-italic">Compila i dati con le tue preferenze.</label><br>
    <label *ngIf="profileSex == 'M'" class="font-italic">Ricorda! Più sarai specifico, più sarà semplice trovare il lavoro su misura per te.</label>
    <label *ngIf="profileSex == 'F'" class="font-italic">Ricorda! Più sarai specifica, più sarà semplice trovare il lavoro su misura per te.</label>
  </div>
</div>
<div class="col-12 flex flex-wrap p-6">
  <div class="w-full field flex">
    <label class="mt-2 labelWidth">Tipo di mansione</label>
    <div class="w-full block">
      <p-autoComplete [(ngModel)]="lstLavoroDesiderato"
                      [suggestions]="taskList"
                      field="MansioneDesc"
                      (completeMethod)="getMansioni($event)"
                      styleClass="w-full"
                      class="w-full"
                      appendTo="body"
                      [dropdown]="true"
                      name="task"
                      [multiple]="true">
        <ng-template let-task pTemplate="item">
          <div class="person-item">
            <div>{{task.MansioneDesc}}</div>
          </div>
        </ng-template>
      </p-autoComplete>
    </div>
  </div>

<!-- ORARIO PREFERENZE -->

  <div class="w-full field flex">
    <label class="mt-2 labelWidth">Orario</label>
    <div class="w-full block">
      <p-autoComplete [(ngModel)]="registryOtherInfo.DisponibilitaOrario"
                      [suggestions]="lstTipoOrari"
                      [dropdown]="true"
                      field="Value"
                      (completeMethod)="getOrarioPreferenze($event)"
                      styleClass="w-full"
                      class="w-full"
                      name="task"
                      [multiple]="true"
                      >
        <ng-template let-task pTemplate="item">
          <div>{{task.Value}}</div>

        </ng-template>
      </p-autoComplete>
    </div>
  </div>

<!-- JRADIOBUTTON CORSI-->
  <div class="w-full field flex mt-3">
    <label *ngIf="profileSex == 'M'" class="mt-2 col-5 p-0">Sei disposto a frequentare corsi di formazione ? </label>
    <label *ngIf="profileSex == 'F'" class="mt-2 col-5 p-0">Sei disposta a frequentare corsi di formazione ? </label>

    <div class="col block">
      <p-radioButton class="p-radiobutton-label-on-white" name="disponibileCorsiGroup" [value]="true" label="Si"
                     [(ngModel)]="registryOtherInfo.VarieCV.DisponibilitaFrequentareCorsi" #disponibileCorsiGroup='ngModel'></p-radioButton>
      <p-radioButton name="disponibileCorsiGroup" [value]="false" label="No" styleClass="ml-5"
                     [(ngModel)]="registryOtherInfo.VarieCV.DisponibilitaFrequentareCorsi" #disponibileCorsiGroup='ngModel' (onClick)="flushField()"></p-radioButton>
    </div>
  </div>

  <div class="w-full field flex" *ngIf ="registryOtherInfo.VarieCV.DisponibilitaFrequentareCorsi">
    <label class="mt-2 labelWidth">Corsi di formazione</label>
    <div class="w-full block">
      <p-autoComplete [(ngModel)]="registryOtherInfo.CorsiFormazione"
                      [suggestions]="lstCorsiFormazione"
                      field="CorsoDesc"
                      (completeMethod)="getRicercaCorsi($event)"
                      styleClass="w-full"
                      [disabled]="!registryOtherInfo.VarieCV.DisponibilitaFrequentareCorsi"
                      class="w-full"
                      appendTo="body"
                      [dropdown]="true"
                      name="task"
                      [multiple]="true"
                      onfocus="this.value=''">
        <ng-template let-task pTemplate="item">
          <div>{{task.CorsoDesc}}</div>

        </ng-template>
      </p-autoComplete>
    </div>
  </div>

<!-- JRADIOBUTTON POLITICHE-->
  <div class="w-full field flex">
    <label *ngIf="profileSex == 'M'" class="mt-2 col-5 p-0">Sei disposto a frequentare percorsi di politiche attive?</label>
    <label *ngIf="profileSex == 'F'" class="mt-2 col-5 p-0">Sei disposta a frequentare percorsi di politiche attive?</label>

    <div class="col block">
      <p-radioButton name="disponibilePoliticheAttiveGroup" [value]="true" label="Si"
                     [(ngModel)]="registryOtherInfo.VarieCV.DisponibilitaPolitcheAttive" #disponibilePolitcheAttiveGroup='ngModel'></p-radioButton>
      <p-radioButton name="disponibilePoliticheAttiveGroup" [value]="false" label="No" styleClass="ml-5"
                     [(ngModel)]="registryOtherInfo.VarieCV.DisponibilitaPolitcheAttive" #disponibilePolitcheAttiveGroup='ngModel'></p-radioButton>

    </div>
  </div>
  <div class="col-12 flex justify-content-end p-0">
    <div class="col-12 lg:col-2 p-0">
      <button pButton pRipple label="Salva" class="w-full p-button-rounded" (click)="getPreferencesUpsert()"></button>
    </div>
  </div>
</div>
